export const MAX_DISPLAYABLE_JOBS = 2;
